export default __webpack_public_path__ + "static/media/Inbond_B.41cd252c.svg";